import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ProductEditForm from '@components/shared/products/ProductEdit';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';

const OperatorProductNew: React.FC = () => {
  return (
    <MerchantSelect>
      {({ merchantId }) => (
        <ProductEditForm
          useProductService={useOperatorProductService}
          role="operator"
          merchantId={merchantId}
        />
      )}
    </MerchantSelect>
  );
};

export default OperatorProductNew;
